export const redirect = (location) => {
  if (window) {
    window.location = location;
  }
};

export default redirect;



// WEBPACK FOOTER //
// ./src/common/utils/redirect.js